




import Vue from "vue";
import { Component } from "vue-property-decorator";
import { INotificationHook } from "@/models/notifications";

@Component({
  components: {
    "automation-trigger": () =>
      import("@/components/app/admin/automation/trigger.vue")
  }
})
export default class AdminAutomationTrigger extends Vue {
  public hookId!: INotificationHook["id"];

  public created() {
    this.hookId = this.$_.get(this.$route.params, "hookId", "");
  }
}
